
import {
    prmedia_thermatru_press_release,
    prmedia_thermatru_press_release_ve,
    prmedia_thermatru_press_release_shaker,
    prmedia_thermatru_press_release_retracable,
    prmedia_thermatru_press_release_nhvs,
    prmedia_thermatru_press_release_ke2scs,
    prmedia_thermatru_press_release_impressions,
    prmedia_thermatru_press_release_ccm34,
    prmedia_thermatru_press_release_thrive,
    prmedia_thermatru_press_release_bottom
} from "./modal_content_data/prmedia/thermatru/press_release"
import {
    prmedia_thermatru_brochures,
    prmedia_thermatru_brochures_36_side_solu,
    prmedia_thermatru_brochures_36_side_solu1,
    prmedia_thermatru_brochures_36_side_solu2,
    prmedia_thermatru_brochures_side_solu,
    prmedia_thermatru_brochures_craft,
    prmedia_thermatru_brochures_sidelte,
    prmedia_thermatru_brochures_glazed_designs,
    prmedia_thermatru_brochures_fiberglass_wood,
    prmedia_thermatru_brochures_smart_investment,
    prmedia_thermatru_brochures_impact_rated,
    prmedia_thermatru_brochures_multi_family,
    prmedia_thermatru_brochures_why,
    prmedia_thermatru_brochures_2022_cat,
    prmedia_thermatru_brochures_enchanced_security,
    prmedia_thermatru_brochures_2022_trends,
    prmedia_thermatru_brochures_thrive

} from "./modal_content_data/prmedia/thermatru/brochures"
import {
    prmedia_thermatru_product_flyer,
    prmedia_thermatru_product_flyer_classic_craft,
    prmedia_thermatru_product_flyer_impression,
    prmedia_thermatru_product_flyer_retractable,
    prmedia_thermatru_product_flyer_shaker,
    prmedia_thermatru_product_flyer_smoother,
    prmedia_thermatru_product_flyer_smoother1,
    prmedia_thermatru_product_flyer_smoother2,
    prmedia_thermatru_product_flyer_smoother3,
    prmedia_thermatru_product_flyer_smoother4,
    prmedia_thermatru_product_flyer_smoother5,

} from "./modal_content_data/prmedia/thermatru/product_flyer"


import { prmedia_thermatru_company_background } from "./modal_content_data/prmedia/thermatru/company_background"
import { prmedia_thermatru_product_images } from "./modal_content_data/prmedia/thermatru/product_images"
import { prmedia_thermatru_product_logos } from "./modal_content_data/prmedia/thermatru/logos"



const baseUrl = process.env.REACT_APP_S3_BUCKET_BASE_URL;

export const _popup_config = [

    {
        ref: 'thermatru_thrives',
        area :'The Therma-Tru Difference',
        title: 'Thermatru Thrives',
        defaultType: 'video',
        childType: 'navigation',
        info_default_view: true,
        info_navigation_view: false,
        infoNavigationComponents: [],
        navigationLevel: 0,
        ContentComponents: [
            {
                navigation_ref: 'therma_thirve_tru_video',
                type: 'vimeo',
                path: 'https://vimeo.com/783160073',
                title: 'Therma-Tru Thrive Video'
            },
            {
                navigation_ref: 'thermatru_thrive_brochure',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/thermatru_difference/thermatru_thrive/23_TT_Bro_Thrive.pdf',
                title: 'Therma-Tru Thrive Brochure'
            },


        ],
        navigationComponents: [
            { key: 'therma_thirve_tru_video', name: 'Therma-Tru Thrive Video', slider: true },
            { key: 'thermatru_thrive_brochure', name: 'Therma-Tru Thrive Brochure', slider: true },
        ]

    },
    {
        ref: 'experience_thermatru',
        area :'The Therma-Tru Difference',
        title: 'Experience Thermatru',
        defaultType: 'video',
        childType: 'navigation',
        info_default_view: true,
        info_navigation_view: false,
        navigationLevel: 0,
        ContentComponents: [
            {
                navigation_ref: 'therma_tru_video',
                type: 'vimeo',
                path: 'https://vimeo.com/768393606',
                title: 'Therma Tru Video'
            },
            {
                navigation_ref: 'builder_brand_leader',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/Builder Brand Leader Flyer.pdf',
                title: 'Builder Brand Leader Flyer'
            },

        ],
        navigationComponents: [
            { key: 'therma_tru_video', name: 'Therma-Tru Video', slider: true },
            { key: 'builder_brand_leader', name: 'Builder Brand Leader Flyer', slider: true },
        ]

    },

    {
        ref: 'fiberglass_full_advantage',
        area :'The Therma-Tru Difference',
        title: 'Fibreglass Full System Advantage',
        defaultType: 'video',
        childType: 'navigation',
        info_default_view: true,
        info_navigation_view: false,
        navigationLevel: 0,
        ContentComponents: [
            {
                navigation_ref: 'build_for_saftey_security',
                type: 'vimeo',
                path: 'https://vimeo.com/766815525',
                title: 'Built for Saftey & Security Video'
            },
            {
                navigation_ref: 'door_system_brochure',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/thermatru_difference/system_advantage/23_Bro_SystemComponents.pdf',
                title: 'Door System Brochure'
            },
            {
                navigation_ref: 'build_for_saftey_security_flyer',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/thermatru_difference/system_advantage/23_Flyer_EnhancedSecurity.pdf',
                title: 'Built for Saftey & Security Flyer'
            },
            {
                navigation_ref: 'explore_the_full_door_system',
                type: 'redirect_url',
                path: 'https://www.thermatru.com/explore-products/components-and-accessories#tab=all',
                title: 'Explore the Full Door System'
            },

            {
                navigation_ref: 'explore_the_full_door_system',
                type: '',
                path: '',
                title: 'For Veris System information visit Trends & New Products'
            },
        ],
        navigationComponents: [
            { key: 'build_for_saftey_security', name: 'Built for Safety & Security Video', slider: true },
            { key: 'door_system_brochure', name: 'Door System Brochure', slider: true },
            { key: 'build_for_saftey_security_flyer', name: 'Built for Safety & Security Flyer', slider: true },
            { key: 'explore_the_full_door_system', name: 'Explore the Full Door System', slider: true, redirect: 'https://www.thermatru.com/explore-products/components-and-accessories#tab=all' },
            { key: 'veris_system_information', name: 'For Veris System information visit Trends & New Products', slider: false },

        ]
    },

    {
        ref: '2023_trends',
        area : 'Trends & New Products',
        title: '2023 Trends',
        defaultType: 'video',
        childType: 'navigation',
        info_default_view: true,
        info_navigation_view: false,
        navigationLevel: 0,
        ContentComponents: [
            {
                navigation_ref: 'new_product_trend_video',
                type: 'vimeo',
                path: 'https://vimeo.com/788173649',
                title: 'New Product & Trends Video'
            },
            {
                navigation_ref: 'tt_new_product_brochure',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/23_Bro_NewProduct.pdf',
                title: 'New Product Brochure'
            },
            {
                navigation_ref: 'explore_the_trends',
                path: '',
                title: 'Explore The Trends',
                type: 'gallery',
                images:
                    [
                        { img: baseUrl + 'datas/thermatru/trends/23_VE_TrendBoard_Casual_6000x10828.jpg', name: '' },
                        { img: baseUrl + 'datas/thermatru/trends/23_VE_TrendBoard_Modern_6000x10828.jpg', name: '' },
                        { img: baseUrl + 'datas/thermatru/trends/23_VE_TrendBoard_Trad_6000x10828.jpg', name: '' },

                    ]
            },

        ],
        navigationComponents: [
            { key: 'new_product_trend_video', name: 'New Product & Trends Video', slider: true },
            { key: 'tt_new_product_brochure', name: 'New Product Brochure', slider: true },
            { key: 'explore_the_trends', name: 'Explore The Trends', slider: true },
        ]
    },


    {
        ref: 'fiberglass_steel_entry_doors',
        area : 'Trends & New Products',
        title: 'Expert Guidance',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 0,
        parent: 'new_products',
        ContentComponents: [


            {
                navigation_ref: 'fiberglass_steel_entry_doors_get_inspired',
                path: '',
                title: 'Explore The Trends',
                type: 'gallery',
                images:
                    [
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/1.jpg', name: 'Pulse Línea Door in Golden Wheat and Onyx with Echelon Glass – S81EC' },
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/2.jpg', name: 'Impressions System in Black – IM100; Fiber-Classic Mahogany in Raven with Calix Glass – FCM220, FCM2389SL' },
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/3.jpg', name: 'Fiber-Classic Mahogany Door & Sidelites in Acorn with Saratoga Glass – FCM86240, FCM86201SL' },
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/4.jpg', name: 'Smooth-Star Doors in Onyx with Latitude Glass – S4525' },
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/5.jpg', name: 'Pulse Ari Doors in Canyon with Echelon Glass – S83EC' },
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/6.jpg', name: 'Fiber-Classic Mahogany Door in Acorn with Calix Glass – FCM82223' },
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/7.jpg', name: 'Smooth-Star Door in Arctic Ice with Calix Glass – S3540' },
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/8.jpg', name: 'Smooth-Star Doors in Alpine with Clear Glass and SDLs – S128' },
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/9.jpg', name: 'Smooth-Star Door & Sidelites in Estuary with Clear Glass and SDLs – S4814, S4812SL' },
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/10.jpg', name: 'Classic Craft Walnut Door in Tumbleweed – CCW8901L; Direct Set Sidelites with Low-E Glass – DRS82131SL' },
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/11.jpg', name: 'Smooth-Star Door in Estuary with Calix Glass – S4521' },
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/12.jpg', name: 'Impressions System in Black – IM100; Fiber-Classic Mahogany in Raven with Clear Glass – FCM4816, FCM4812SL' },
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/13.jpg', name: 'Smooth-Star Door in Arctic Ice with Calix Glass – S2223' },
                        { img: baseUrl + 'datas/thermatru/newproducts/fibrglass/14.jpg', name: 'Impressions System in White – IM100; Fiber - Classic Mahogany Door in Tumbleweed with Chord Glass – FCM84810XC' },


                    ]
            },

            // {
            //     navigation_ref: 'fiberglass_steel_entry_doors_explore_more',
            //     type: 'image',
            //     path: baseUrl + 'datas/thermatru/trends/Veris Get Inspired Placeholder.jpg',
            //     title: ''
            // },
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_design',
                type: '',
                path: '',
                title: 'Glass Designs'
            },
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_design_shaker',
                type: '',
                path: '',
                title: 'Craftsman Shaker-Style Options'
            },
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_prisma_guard',
                type: '',
                path: '',
                title: 'PrismaGuard Finish'
            },
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_impression_storm',
                type: '',
                path: '',
                title: 'Impressions Storm & Entry Door System Options'
            },
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_advanta_lite',
                type: '',
                path: '',
                title: 'Advanta Lite Frame'
            },
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_alpine_white_color',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/alpine_white.pdf',
                title: 'Alpine White Color-Matched Lite Frame & SDLs'
            },
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_classic_craft',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/23_Bro_ClassicCraft.pdf',

                title: 'Classic Craft Brochure'
            },
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_classic_glass_brochure',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/23_Bro_Glass.pdf',
                title: 'Glass Brochure'
            },
        ],
        navigationComponents: [
            { key: 'fiberglass_steel_entry_doors_get_inspired', name: 'Get Inspired', class: 'wid_100', slider: true },
            // { key: 'fiberglass_steel_entry_doors_explore_more', name: 'Explore More', class: 'wid_50', slider: true },
            { key: 'fiberglass_steel_entry_doors_glass_design', name: 'Glass Designs', slider: true,keyimg : true },
            { key: 'fiberglass_steel_entry_doors_glass_design_shaker', name: 'Craftsman Shaker-Style Options', class: '', slider: true ,keyimg : true},
            { key: 'fiberglass_steel_entry_doors_glass_prisma_guard', name: 'PrismaGuard Finish', class: '', slider: true,keyimg : true },
            { key: 'fiberglass_steel_entry_doors_glass_impression_storm', name: 'Impressions Storm & Entry Door System Options', class: '', slider: true ,keyimg : true},
            { key: 'fiberglass_steel_entry_doors_glass_advanta_lite', name: 'Advanta Lite Frame', class: '', slider: true,keyimg : true },
            { key: 'fiberglass_steel_entry_doors_glass_alpine_white_color', name: 'Alpine White Color-Matched <br> Lite Frame & SDLs', class: '', slider: true },
            { key: 'fiberglass_steel_entry_doors_glass_classic_craft', name: 'Classic Craft Brochure', class: 'wid_50', slider: true },
            { key: 'fiberglass_steel_entry_doors_glass_classic_glass_brochure', name: 'Glass Brochure', class: 'wid_50', slider: true },


        ]


    },


    {
        ref: 'fiberglass_steel_entry_doors_glass_advanta_lite',
        area : 'Trends & New Products',

        title: 'Expert Guidance',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 0,
        parent: 'fiberglass_steel_entry_doors',

        ContentComponents: [
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_advanta_lite_video',
                type: 'vimeo',
                path: 'https://vimeo.com/769298333',
                title: 'Advanta Lite Frame Video'
            },
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_advanta_lite_brochure',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/23_Flyer_Advanta.pdf',
                title: 'Advanta Lite Frame Flyer'
            },

        ],
        navigationComponents: [
            { key: 'fiberglass_steel_entry_doors_glass_advanta_lite_video', name: 'Advanta Lite Frame Video', slider: true, keyimg: true },
            { key: 'fiberglass_steel_entry_doors_glass_advanta_lite_brochure', name: 'Advanta Lite Frame Flyer', slider: true },
        ]


    },
    {
        ref: 'fiberglass_steel_entry_doors_glass_impression_storm',
        area : 'Trends & New Products',

        title: 'Expert Guidance',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 0,
        parent: 'fiberglass_steel_entry_doors',

        ContentComponents: [
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_impression_storm_video',
                type: 'vimeo',
                path: 'https://vimeo.com/771054417',
                title: 'Impressions Storm & Entry <br> Door System Video'
            },
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_impression_storm_brochure',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/23_Flyer_Impressions_Phase2.pdf',
                title: 'Impressions Storm & Entry <br> Door System Brochure'
            },

        ],
        navigationComponents: [
            { key: 'fiberglass_steel_entry_doors_glass_impression_storm_video', name: 'Impressions Storm & Entry <br> Door System Video', slider: true, keyimg: true },
            { key: 'fiberglass_steel_entry_doors_glass_impression_storm_brochure', name: 'Impressions Storm & Entry <br> Door System Brochure', slider: true },
        ]


    },
    {
        ref: 'fiberglass_steel_entry_doors_glass_prisma_guard',
        area : 'Trends & New Products',

        title: 'Expert Guidance',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 0,
        parent: 'fiberglass_steel_entry_doors',

        ContentComponents: [
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_prisma_guard_video',
                type: 'vimeo',
                path: 'https://vimeo.com/774935321',
                title: 'PrismaGuard Finish Video'
            },
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_prisma_guard_brochure',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/23_TT_Bro_PrismaGuard_SinglePgs.pdf',
                title: 'PrismaGuard Finish Brochure'
            },

        ],
        navigationComponents: [
            { key: 'fiberglass_steel_entry_doors_glass_prisma_guard_video', name: 'PrismaGuard Finish Video', slider: true, keyimg: true },
            { key: 'fiberglass_steel_entry_doors_glass_prisma_guard_brochure', name: 'PrismaGuard Finish Brochure', slider: true },
        ]


    },
    {
        ref: 'fiberglass_steel_entry_doors_glass_design_shaker',
        area : 'Trends & New Products',

        title: 'Expert Guidance',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 0,
        parent: 'fiberglass_steel_entry_doors',
        ContentComponents: [
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_design_shaker_video',
                type: 'vimeo',
                path: 'https://vimeo.com/769293830',
                title: 'Craftsman Shaker-Style Options Video'
            },
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_design_shaker_brochure',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/shaker_pdf.pdf',
                title: 'Craftsman Shaker-Style Options Flyer'
            },

        ],
        navigationComponents: [
            { key: 'fiberglass_steel_entry_doors_glass_design_shaker_video', name: 'Craftsman Shaker-Style <br> Options Video', slider: true, keyimg: true },
            { key: 'fiberglass_steel_entry_doors_glass_design_shaker_brochure', name: 'Craftsman Shaker-Style <br>  Options Flyer', slider: true },
        ]


    },
    {
        ref: 'fiberglass_steel_entry_doors_glass_design',
        area : 'Trends & New Products',

        title: 'Expert Guidance',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 0,
        parent: 'fiberglass_steel_entry_doors',

        ContentComponents: [
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_design_video',
                type: 'vimeo',
                path: 'https://vimeo.com/769285097',
                title: 'Glass Designs Video'
            },
            {
                navigation_ref: 'fiberglass_steel_entry_doors_glass_design_brochure',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/Glass Designs Brochure Placeholder.pdf',
                title: 'Glass Designs Brochure'
            },

        ],
        navigationComponents: [
            { key: 'fiberglass_steel_entry_doors_glass_design_video', name: 'Glass Designs Video', slider: true, keyimg: true },
            { key: 'fiberglass_steel_entry_doors_glass_design_brochure', name: 'Glass Designs Brochure', slider: true },
        ]


    },
    {
        ref: 'veris_collection',
        area : 'Trends & New Products',

        title: 'Expert Guidance',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 0,
        parent: 'new_products',
        ContentComponents: [
            {
                navigation_ref: 'veris_collection_video',
                type: 'vimeo',
                path: 'https://vimeo.com/797585706',
                title: 'New Product & Trends Video'
            },
            {
                navigation_ref: 'veris_collection_brochure',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/23_Bro_Veris_Sprds.pdf',
                title: 'Veris Collection Brochure'
            },

            {
                navigation_ref: 'veris_collection_get_inspired',
                path: '',
                title: 'Explore The Trends',
                type: 'gallery',
                images:
                    [
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/1-VE_Home_VFold-Out_1L3R_3080_DkBronze_Deck_SAN_Chai.jpg', name: 'Veris Collection Folding Doors in Dark Bronze Anodized with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/2-VE_Home_VHinge-Out_OXXO_3080_22SL_White_INT.jpg', name: 'Veris Collection Hinged Doors and Sidelites in White with Enhanced Low-E Glass and SDLs' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/3-VE_Home_VSlide_XXOR_4068_ClearAnodized.jpg', name: 'Veris Collection Sliding Doors in Clear Anodized with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/4-VE_Home_VPivot_OX_4080-18SL_Reeded_Black.jpg', name: 'Veris Collection Pivot Door and Sidelite in Black with Reeded Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/5-VE_Home_VFold-Out_5R_3080_Black-2_Fypon_Fiberon.jpg', name: 'Veris Collection Folding Doors in Black with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/6-VE_Home_VHinge-Out_X_3068_Black.jpg', name: 'Veris Collection Hinged Door in Black with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/7-VE_Home_VSlide-XOR_XXXOR_5080_DkBronze.jpg', name: 'Veris Collection Sliding Doors in Dark Bronze Anodized with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/8-VE_Home_VPivot-In_X_40100_Black.jpg', name: 'Veris Collection Pivot Door in Black with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/9-VE_Home_VFold-Out-2x4SDL_1L3R_3080_DkBronze.jpg', name: 'Veris Collection Folding Doors in Dark Bronze Anodized with Enhanced Low-E Glass and SDLs' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/10-VE_Home_VHinge-In_OXO_3080_18SL_White.jpg', name: 'Veris Collection Hinged Doors and Sidelites in White with Enhanced Low-E Glass and SDLs' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/11-VE_Home_VHinge-Out_X_3668_VSlide-XXXPR_Black_FiberonDecking.jpg', name: 'Veris Collection Hinged Door and Sliding Doors in Black with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/12-VE_Home_VPivot_X_3080_1x3-Clear_Black.jpg', name: 'Veris Collection Pivot Door in Black with Enhanced Low-E and SDLs' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/13-VE_Home_VFold-Out_1L3R_3068_Charcoal.jpg', name: 'Veris Collection Folding Doors in Charcoal with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/14-VE_Home_VHinge-Infold_OXO-1x3_3080_22SL_Black.jpg', name: 'Veris Collection Hinged Door and Sidelites in Black with Enhanced Low-E Glass and SDLs' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/15.jpg', name: 'Veris Collection Sliding Doors in White with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/16.jpg', name: 'Veris Collection Pivot Door and Sidelites in Black with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/17.jpg', name: 'Veris Collection Folding Doors in Black with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/18.jpg', name: 'Veris Collection Hinged Doors in Black with  Enhanced Low-E Glass and SDLs' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/19.jpg', name: 'Veris Collection Sliding Doors in Clear Anodized with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/20.jpg', name: 'Veris Collection Pivot Door in Clear Anodized with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/21.jpg', name: 'Veris Collection Folding Doors in Black with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/22.jpg', name: 'Veris Collection Hinged Doors in Black with Enhanced Low-E Glass and SDLs' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/23.jpg', name: 'Veris Collection Pivot Door and Sidelites in Black with Enhanced Low-E Glass and SDLs' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/24.jpg', name: 'Veris Collection Folding Doors in White with Enhanced Low-E Glass' },
                        { img: baseUrl + 'datas/thermatru/newproducts/veriscollection/25.jpg', name: 'Veris Collection Hinged Doors and Sidelites in Black with Enhanced Low-E Glass' },
                    ]
            },



            {
                navigation_ref: 'veris_collection_pivot_door_systems',
                type: '',
                path: '',
                title: ''
            },
            {
                navigation_ref: 'veris_collection_hinged_door_systems',
                type: '',
                path: '',
                title: ''
            },
            {
                navigation_ref: 'veris_collection_folding_door_systems',
                type: '',
                path: '',
                title: ''
            },
            {
                navigation_ref: 'veris_collection_sliding_door_systems',
                type: '',
                path: '',
                title: ''
            },

        ],
        navigationComponents: [
            { key: 'veris_collection_video', name: 'Veris Collection Video', class: '', slider: true, keyimg: true },
            { key: 'veris_collection_brochure', name: 'Veris Collection Brochure', class: '', slider: true },
            { key: 'veris_collection_get_inspired', name: 'Get Inspired', class: '', slider: true },
            { key: 'veris_collection_pivot_door_systems', name: 'Pivot Door Systems', class: 'wid_25', slider: true },
            { key: 'veris_collection_hinged_door_systems', name: 'Hinged Door Systems', class: 'wid_25', slider: true },
            { key: 'veris_collection_folding_door_systems', name: 'Folding Door Systems', class: 'wid_25', slider: true },
            { key: 'veris_collection_sliding_door_systems', name: 'Sliding Door Systems', class: 'wid_25', slider: true },



        ]


    },

    {
        ref: 'veris_collection_sliding_door_systems',
        area : 'Trends & New Products',

        title: 'Expert Guidance',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 0,
        parent: 'veris_collection',
        ContentComponents: [
            {
                navigation_ref: 'veris_collection_sliding_door_systems_pivot_cut_sheet',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/23_Flyer_Veris_Sliding.pdf',
                title: 'Sliding Product Details Cut Sheet'
            },
            {
                navigation_ref: 'veris_collection_sliding_door_systems_explore_system',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/Veris Sliding Door System.pdf',
                title: 'Veris Sliding Door System'
            },
            {
                navigation_ref: 'veris_collection_sliding_door_systems_visualise',
                type: 'image',
                path: baseUrl + 'datas/thermatru/trends/23_VE_Veris_Sliding.jpg',
                title: ''
            },

        ],
        navigationComponents: [
            { key: 'veris_collection_sliding_door_systems_pivot_cut_sheet', name: 'Product Details Cut Sheet', slider: true },
            { key: 'veris_collection_sliding_door_systems_explore_system', name: 'Explore The System', slider: true },
            { key: 'veris_collection_sliding_door_systems_visualise', name: 'Visualize It <br> Arriving March, 2023', redirect: 'https://veriscollection.com/slidingdoor', slider: true },
        ]


    },
    {
        ref: 'veris_collection_folding_door_systems',
        area : 'Trends & New Products',

        title: 'Expert Guidance',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 0,
        parent: 'veris_collection',

        ContentComponents: [
            {
                navigation_ref: 'veris_collection_folding_door_systems_pivot_cut_sheet',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/23_Flyer_Veris_Fldg.pdf',
                title: 'Folding Product Details Cut Sheet'
            },
            {
                navigation_ref: 'veris_collection_folding_door_systems_explore_system',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/Veris Folding Door System.pdf',
                title: 'Veris Folding Door System'
            },
            {
                navigation_ref: 'veris_collection_folding_door_systems_visualise',
                type: 'image',
                path: baseUrl + 'datas/thermatru/trends/23_VE_Veris_Folding.jpg',
                title: ''
            },

        ],
        navigationComponents: [
            { key: 'veris_collection_folding_door_systems_pivot_cut_sheet', name: 'Product Details Cut Sheet', slider: true },
            { key: 'veris_collection_folding_door_systems_explore_system', name: 'Explore The System', slider: true },
            { key: 'veris_collection_folding_door_systems_visualise', name: 'Visualize It <br> Arriving March, 2023', redirect: 'https://veriscollection.com/foldingdoor', slider: true },
        ]


    },

    {
        ref: 'veris_collection_hinged_door_systems',
        area : 'Trends & New Products',

        title: 'Expert Guidance',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 0,
        parent: 'veris_collection',

        ContentComponents: [
            {
                navigation_ref: 'veris_collection_hinged_door_systems_pivot_cut_sheet',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/23_Flyer_Veris_Hinged.pdf',
                title: 'Hinged Product Details Cut Sheet'
            },
            {
                navigation_ref: 'veris_collection_hinged_door_systems_explore_system',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/Veris Hinged Door System.pdf',
                title: 'Veris Hinged Door System'
            },

            {
                navigation_ref: 'veris_collection_hinged_door_systems_visualise',
                type: 'image',
                path: baseUrl + 'datas/thermatru/trends/23_VE_Veris_Hinged.jpg',
                title: 'Visualize It'
            },

        ],
        navigationComponents: [
            { key: 'veris_collection_hinged_door_systems_pivot_cut_sheet', name: 'Product Details Cut Sheet', slider: true },
            { key: 'veris_collection_hinged_door_systems_explore_system', name: 'Explore The System', slider: true },
            { key: 'veris_collection_hinged_door_systems_visualise', name: 'Visualize It <br> Arriving March, 2023', redirect: 'https://veriscollection.com/hingeddoor', slider: true },
        ]


    },

    {
        ref: 'veris_collection_pivot_door_systems',
        area : 'Trends & New Products',

        title: 'Expert Guidance',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 0,
        parent: 'veris_collection',

        ContentComponents: [
            {
                navigation_ref: 'veris_collection_pivot_door_systems_pivot_cut_sheet',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/23_Flyer_Veris_Pivot.pdf',
                title: 'Pivot Product Details Cut Sheet'
            },
            {
                navigation_ref: 'veris_collection_pivot_door_systems_explore_system',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/trends/Veris Pivot Door System.pdf',
                title: 'Veris Pivot Door System'
            },
            {
                navigation_ref: 'veris_collection_pivot_door_systems_visualise',
                type: 'image',
                path: baseUrl + 'datas/thermatru/trends/23_VE_Veris_Pivot.jpg',
                title: 'Visualize It'
            },

        ],
        navigationComponents: [
            { key: 'veris_collection_pivot_door_systems_pivot_cut_sheet', name: 'Product Details Cut Sheet', slider: true },
            { key: 'veris_collection_pivot_door_systems_explore_system', name: 'Explore The System', slider: true },
            { key: 'veris_collection_pivot_door_systems_visualise', name: 'Visualize It <br> Arriving March, 2023', redirect: 'http://veriscollection.com/pivotdoor', slider: true },
        ]


    },

    {
        ref: 'new_products',
        area : 'Trends & New Products',

        title: 'New Products',
        defaultType: 'image',
        childType: 'navigation',
        info_default_view: true,
        info_navigation_view: false,
        navigationLevel: 0,
        ContentComponents: [
            {
                type: 'imageArray',
                imgArray: [
                    baseUrl + 'datas/thermatru/newproducts/23_VE_ExpTT_PopUp_Veris_420x475.jpg',
                    baseUrl + 'datas/thermatru/newproducts/23_VE_ExpTT_PopUp_ThermaTru_420x475.jpg',
                ],
                path: '',
                title: 'New Product & Trends Video'
            },
        ],
        navigationComponents: [
            { key: 'veris_collection', name: 'Veris Collection', slider: true ,keyimg : true },
            { key: 'fiberglass_steel_entry_doors', name: 'Fiberglass & Steel Entry Doors', slider: true ,keyimg : true},
        ]
    },



    {
        ref: 'tools_explore_more',
        area : 'Tools & Support Thermatru',
        title: 'Explore More Tools',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 2,
        navigation_box: '',
        discription: 'Tools & Support',
        ContentComponents: [

            {
                navigation_ref: 'door_system',
                type: 'navigation_box',
                title: 'Door System Brochure',
                discription: 'Tools & Support',
                buttonList: [
                    {
                        key : 'thermatru_tools_support_btn1',
                        title: 'Literature',
                        area : 'Tools & Support Thermatru',

                        type: 'redirect',
                        path: 'https://www.thermatru.com/inspiration/literature/',
                    },
                    {
                        key : 'thermatru_tools_support_btn2',
                        area : 'Tools & Support Thermatru',

                        title: 'Product Merchandising Tools',
                        type: 'redirect',
                        path: 'https://outdoorsandsecurity.widen.net/s/htxz2zncgn/22_product-merchandising-aids-brochure',
                    },
                    {
                        key : 'thermatru_tools_support_btn3',
                        area : 'Tools & Support Thermatru',

                        title: 'Samples',
                        type: 'redirect',
                        path: 'https://store.thermatru.com/collections/therma-tru-samples',
                    },
                    {
                        key : 'thermatru_tools_support_btn4',
                        area : 'Tools & Support Thermatru',

                        title: 'Popular Home Styles',
                        type: 'redirect',
                        path: 'https://apps.metzgers.com/customers/21-8113-4/',
                    },
                    {
                        key : 'thermatru_tools_support_btn5',
                        area : 'Tools & Support Thermatru',

                        title: 'The Importance of Curb Appeal',
                        type: 'redirect',
                        path: 'https://www.thermatru.com/inspiration/increasing-your-curb-appeal/',
                    },
                    {

                        key : 'thermatru_tools_support_btn6',
                        area : 'Tools & Support Thermatru',

                        title: 'Advancement Center - Coming Soon',
                        type: 'redirect',
                        path: 'https://www.brainshark.com/brainshark/public/login/m/login2.asp?companyid=2882425',
                        
                    },
                    {

                        key : 'thermatru_tools_support_btn7',
                        area : 'Tools & Support Thermatru',

                        title: 'Digital Vault',
                        type: 'redirect',
                        path: 'https://outdoorsandsecurity.widencollective.com/',
                    },
                    {
                        key : 'thermatru_tools_support_btn8',
                        area : 'Tools & Support Thermatru',

                        title: 'Model Home Program',
                        type: 'redirect',
                        path: 'https://outdoorsandsecurity.widen.net/view/pdf/8net4c7eaw/22_Builder_SellSht_ModelHome-1.19.22.pdf?t.download=true&u=0cghrp',
                    },
                    {
                        key : 'thermatru_tools_support_btn9',
                        area : 'Tools & Support Thermatru',

                        title: 'Company Store',
                        type: 'redirect',
                        path: 'https://store.thermatru.com/collections/branded-items',
                    },
                ]
            },

        ],
        navigationComponents: [
            // { key : 'door_system' , name: 'Door System Brochure'},

        ],


    },

    {
        ref: 'expert_guidance',
        area : 'Certified Installer Training Program',
        title: 'Expert Guidance',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 0,

        ContentComponents: [
            {
                navigation_ref: 'expert_guidance_video',
                type: 'vimeo',
                path: 'https://vimeo.com/773197326',
                title: 'New Product & Trends Video'
            },
            {
                navigation_ref: 'expert_guidance_flyer',
                type: 'pdf',
                path: baseUrl + 'datas/thermatru/certified_installer/23_TT_CertInstaller_DualSidedFlyer.pdf',
                title: 'Certified Installer Training Program Flyer'
            },
            {
                navigation_ref: 'expert_guidance_training',
                type: 'pdf',
                path: '',
                title: ''
            },
            {
                navigation_ref: 'expert_register',
                type: '',
                path: '',
                title: ''
            },

        ],
        navigationComponents: [
            { key: 'expert_guidance_video', name: 'Training Overview Video', slider: true },
            { key: 'expert_guidance_flyer', name: "Certified Installer Training <br> Program Flyer", slider: true },
            { key: 'expert_guidance_training', name: 'Access Training', redirect: 'https://www.thermatrucertifiedinstaller.com/', slider: true },
            { key: 'expert_register', name: 'Register', redirect: 'https://form.jotform.com/thermatru/certified-installer-training-regist', slider: true },

        ]


    },

    //Starting Fypon Info Data
    {
        ref: 'discover_fypon',
        area : 'The Fypon Advantage',
        title: 'Discover Fypon',
        defaultType: 'video',
        childType: 'navigation',
        navigationLevel: 0,
        ContentComponents: [
            {
                navigation_ref: 'fypon_brand_video',
                type: 'vimeo',
                path: 'https://vimeo.com/769349915',
                title: 'Fypon Brand Video',
                color: 'blue',
            },
            {
                navigation_ref: 'builder_brand',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponadvantage/discover_fypon/Builder Brand Leader Flyer.pdf',
                color: 'blue',
                title: 'Builder Brand Leader Flyer'
            },
            {
                navigation_ref: 'smarter_investment_brochure',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponadvantage/discover_fypon/A Smarter Investment Brochure.pdf',
                color: 'blue',
                title: 'A Smarter Investment Brochure'
            },
        ],
        navigationComponents: [
            { key: 'fypon_brand_video', name: 'Fypon Video', slider: true },
            { key: 'builder_brand', name: 'Builder Brand Leader Flyer', slider: true },
            { key: 'smarter_investment_brochure', name: 'A Smarter Investment Brochure', slider: true },
        ]
    },

    {
        ref: 'takeoff_service',
        area : 'The Fypon Advantage',

        title: 'Take Off Service',
        color: 'blue',
        defaultType: 'video',
        navigationLevel: 0,
        ContentComponents: [
            {
                navigation_ref: 'take_off_service_video',
                type: 'vimeo',
                path: 'https://vimeo.com/790667085',
                title: 'Take Off Service Video'
            },
            {
                navigation_ref: 'take_off_service_brochure',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponadvantage/takeoff/Fypon Takeoff Brochure.pdf',
                title: 'Take Off Service Brochure'
            },

        ],
        navigationComponents: [
            { key: 'take_off_service_video', name: 'Takeoff Service Video', slider: true },
            { key: 'take_off_service_brochure', name: 'Takeoff Service Brochure', slider: true },
        ]
    },

    {
        ref: 'shutter_smoother',
        area : 'New Products',
        title: 'Shutter Smoother',
        defaultType: 'video',
        navigationLevel: 0,
        color: 'blue',
        ContentComponents: [
            {
                navigation_ref: 'new_product_video',
                type: 'vimeo',
                title: 'New Product Video',
                path: 'https://vimeo.com/788169844',

            },
            {
                navigation_ref: 'fypon_new_product_brochure',
                type: 'pdf',
                title: 'New Product Brochure',
                path: baseUrl + 'datas/fypon/fyponproducts/23_New Product Brochure.pdf',

            },
            {
                navigation_ref: 'get_inspired',
                title: 'Get Inspired',
                path: '',
                type: 'gallery',
                images:
                    [
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_1.jpg', name: 'Stepped Mantel' },
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_2.jpg', name: 'Raised Panel Shutters' },
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_3.jpg', name: 'Classic Mantel' },
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_4.jpg', name: 'Louvered with Center Rail Shutters' },
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_5.jpg', name: 'Smooth Beam Mantel' },
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_6.jpg', name: 'Stepped Mantel' },
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_7.jpg', name: 'Raised Panel Shutters' },
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_8.jpg', name: 'Classic Mantel' },
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_9.jpg', name: 'Louvered with Center Rail Shutters' },
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_10.jpg', name: 'Smooth Beam Mantel' },
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_11.jpg', name: 'Stepped Mantel' },
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_12.jpg', name: 'Raised Panel Shutters' },
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_13.jpg', name: 'Classic Mantel' },
                        { img: baseUrl + 'datas/fypon/fyponproducts/get_inspired/VE_Images_NewProducts_14.jpg', name: 'Smooth Beam Mantel' },


                    ]


            },
            {
                navigation_ref: 'shutter_fast_facts',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Fypon_FastFacts_RaisedPanelAndLouveredShutters.pdf',
                title : 'Louvered & Raised Panel Shutters Fast Facts'
            },
            {
                navigation_ref: 'smooth_mantels_fast_facts',
                type: 'pdf',
                title: 'Smooth Mantels Fast Facts',
                path: baseUrl + 'datas/fypon/fyponproducts/Fypon_FastFacts_Smooth Mantels.pdf',

            },
        ],
        navigationComponents: [
            { key: 'new_product_video', name: 'New Product Video', slider: true },
            { key: 'fypon_new_product_brochure', name: 'New Product Brochure', slider: true },
            { key: 'get_inspired', name: 'Get Inspired', slider: true },
            { key: 'shutter_fast_facts', name: 'Louvered & Raised Panel Shutters <br> Fast Facts', slider: true },
            { key: 'smooth_mantels_fast_facts', name: 'Smooth Mantels Fast Facts', slider: true },

        ]
    },
    {
        ref: 'fypon_explore_more_tools',
        area : 'Tools & Support Fypon',
        title: 'Explore More Tools',
        color: 'blue',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 2,
        navigation_box: '',
        discription: 'Tools & Support',
        ContentComponents: [

            {
                navigation_ref: 'door_system',
                type: 'navigation_box',
                title: 'Door System Brochure',
                discription: 'Tools & Support',
                styleref: 'fypon_explore_more_tools',
                buttonList: [
                    {

                        key : 'fypon_tools_support_btn1',
                        area : 'Tools & Support Fypon',
                        title: 'Literature',
                        type: 'redirect',
                        path: 'https://fypon.com/pages/literature-library',
                    },
                    {
                        key : 'fypon_tools_support_btn2',
                        area : 'Tools & Support Fypon',

                        title: 'Product Merchandising Tools',
                        type: 'redirect',
                        path: 'https://outdoorsandsecurity.widen.net/view/pdf/gcwxsdbkn8/22_Fypon_MA-Brochure.pdf?t.download=true&u=0cghrp',
                    },
                    {
                        key : 'fypon_tools_support_btn3',
                        area : 'Tools & Support Fypon',

                        title: 'Takeoff Service',
                        type: 'redirect',
                        path: 'https://outdoorsandsecurity.widen.net/view/pdf/zxdwbfcgch/21_Takeoff-Brochure.pdf?t.download=true&u=ho4nsu',
                    },
                    {
                        key : 'fypon_tools_support_btn4',
                        area : 'Tools & Support Fypon',

                        title: 'Style Inspiration',
                        type: 'redirect',
                        path: 'https://fypon.com/pages/fypon-style-inspiration',
                    },
                    {
                        key : 'fypon_tools_support_btn5',
                        area : 'Tools & Support Fypon',

                        title: 'Increasing Curb Appeal',
                        type: 'redirect',
                        path: 'https://fypon.com/pages/increasing-curb-appeal',
                    },
                    {
                        key : 'fypon_tools_support_btn6',
                        area : 'Tools & Support Fypon',

                        title: 'Shop Samples',
                        type: 'redirect',
                        path: 'https://fypon.com/collections/fypon-sample/sample',
                    },
                    {
                        key : 'fypon_tools_support_btn7',
                        area : 'Tools & Support Fypon',

                        title: 'Digital Vault',
                        type: 'redirect',
                        path: 'https://outdoorsandsecurity.widencollective.com/',
                    },
                    {
                        key : 'fypon_tools_support_btn8',
                        area : 'Tools & Support Fypon',

                        title: 'Installation Instructions',
                        type: 'redirect',
                        path: 'https://fypon.com/pages/installation-instructions',
                    },
                    {
                        key : 'fypon_tools_support_btn9',
                        area : 'Tools & Support Fypon',

                        title: 'Continuing Education',
                        type: 'redirect',
                        path: 'https://fypon.com/pages/continuing-education',
                    },
                ]
            },

        ],
        navigationComponents: [
            // { key : 'door_system' , name: 'Door System Brochure'},

        ],


    },


    {
        ref: 'prmedia_thermatru',
        area : 'PR & Media Therma-Tru',
        title: 'Explore More Tools',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 2,
        navigation_box: '',
        ContentComponents: [

            {
                navigation_ref: 'door_system',
                type: 'navigation_box',
                title: 'Door System Brochure',
                footerdiscription: true,
                discription: 'Therma-Tru PR & Media',
                buttonList: [
                    {
                        key : 'prmedia_thermatru_tools_btn1',
                        area : 'PR & Media Therma-Tru',

                        title: 'Press Releases ',
                        type: 'navigationbuttonlist',
                        contentKey: 'prmedia_thermatru_press_release'
                    },
                    {
                        key : 'prmedia_thermatru_tools_btn2',
                        area : 'PR & Media Therma-Tru',

                        title: 'Company Background',
                        type: 'navigationbuttonlist',
                        contentKey: 'prmedia_thermatru_company_background'

                    },
                    {
                        key : 'prmedia_thermatru_tools_btn3',
                        area : 'PR & Media Therma-Tru',

                        title: 'Brochures',
                        type: 'navigationbuttonlist',
                        contentKey: 'prmedia_thermatru_brochures'

                    },
                    {
                        key : 'prmedia_thermatru_tools_btn4',
                        area : 'PR & Media Therma-Tru',

                        title: 'Product Images',
                        type: 'navigationbuttonlist',
                        contentKey: 'prmedia_thermatru_product_images',
                    },
                    {
                        key : 'prmedia_thermatru_tools_btn5',
                        area : 'PR & Media Therma-Tru',

                        title: 'Logos',
                        type: 'navigationbuttonlist',
                        contentKey: 'prmedia_thermatru_product_logos'


                    },
                    {
                        key : 'prmedia_thermatru_tools_btn6',
                        area : 'PR & Media Therma-Tru',

                        title: 'Product Flyers',
                        type: 'navigationbuttonlist',
                        contentKey: 'prmedia_thermatru_product_flyer'


                    },

                ]
            },

        ],
        navigationComponents: [
            // { key : 'door_system' , name: 'Door System Brochure'},

        ],


    },
    prmedia_thermatru_press_release,
    prmedia_thermatru_press_release_ve,
    prmedia_thermatru_press_release_shaker,
    prmedia_thermatru_press_release_retracable,
    prmedia_thermatru_press_release_nhvs,
    prmedia_thermatru_press_release_ke2scs,
    prmedia_thermatru_press_release_impressions,
    prmedia_thermatru_press_release_ccm34,
    prmedia_thermatru_press_release_thrive,
    prmedia_thermatru_press_release_bottom,
    prmedia_thermatru_company_background,
    prmedia_thermatru_brochures,
    prmedia_thermatru_brochures_36_side_solu,
    prmedia_thermatru_brochures_36_side_solu1,
    prmedia_thermatru_brochures_36_side_solu2,

    prmedia_thermatru_brochures_side_solu,
    prmedia_thermatru_brochures_craft,
    prmedia_thermatru_brochures_sidelte,
    prmedia_thermatru_brochures_glazed_designs,
    prmedia_thermatru_brochures_fiberglass_wood,
    prmedia_thermatru_brochures_smart_investment,
    prmedia_thermatru_brochures_impact_rated,
    prmedia_thermatru_brochures_multi_family,
    prmedia_thermatru_brochures_why,
    prmedia_thermatru_brochures_2022_cat,
    prmedia_thermatru_brochures_enchanced_security,
    prmedia_thermatru_brochures_2022_trends,
    prmedia_thermatru_brochures_thrive,
    prmedia_thermatru_product_images,
    prmedia_thermatru_product_logos,


    prmedia_thermatru_product_flyer,
    prmedia_thermatru_product_flyer_classic_craft,
    prmedia_thermatru_product_flyer_impression,
    prmedia_thermatru_product_flyer_retractable,
    prmedia_thermatru_product_flyer_shaker,
    prmedia_thermatru_product_flyer_smoother,
    prmedia_thermatru_product_flyer_smoother1,
    prmedia_thermatru_product_flyer_smoother2,
    prmedia_thermatru_product_flyer_smoother3,
    prmedia_thermatru_product_flyer_smoother4,
    prmedia_thermatru_product_flyer_smoother5,
    {
        area :'PR & Media Fypon',
        ref : 'prmedia_fypon_tools_btn1_press_release',
        navigationLevel : -1,
        type: 'pdf',
        path: baseUrl + 'datas/prmedia/23_Fypon_PressRelease_New Products.pdf',
        parent : 'prmedia_fypon',
        title : 'Press Release'
    },
    {
        area :'PR & Media Fypon',
        ref : 'prmedia_fypon_tools_btn2_company_background',
        navigationLevel : -1,
        type: 'pdf',
        path: baseUrl + 'datas/prmedia/23_Fypon_Backgrounder.pdf',
        parent : 'prmedia_fypon',
        title: 'Company Background',
    },
    {
        area :'PR & Media Fypon',
        ref : 'prmedia_fypon_tools_btn4_product_images',
        navigationLevel : -1,
        title: 'Product Images',
        path: '',
        type: 'gallery',
        images:
            [
                { img: baseUrl + 'datas/prmedia/gallery/1-Fypon Rafter Tails.jpg', name: 'Fypon Rafter Tails' },
                { img: baseUrl + 'datas/prmedia/gallery/2-Fypon Smooth Beam Mantel - 78.jpg', name: 'Fypon Smooth Beam Mantel' },
                { img: baseUrl + 'datas/prmedia/gallery/3-Fypon Beams.jpg', name: 'Fypon Beams' },
                { img: baseUrl + 'datas/prmedia/gallery/4-Fypon Raised Panel Shutters.jpg', name: 'Fypon Raised Panel Shutters' },
                { img: baseUrl + 'datas/prmedia/gallery/5-Fypon Raised Panel Shutters.jpg', name: 'Fypon Raised Panel Shutters' },
                { img: baseUrl + 'datas/prmedia/gallery/6-Fypon Stepped Mantel.jpg', name: 'Fypon Stepped Mantel' },
                { img: baseUrl + 'datas/prmedia/gallery/7-Fypon Stepped Mantel.png', name: 'Fypon Stepped Mantel' },
                { img: baseUrl + 'datas/prmedia/gallery/8-Fypon Smooth Beam Mantel - 90.png', name: 'Fypon Smooth Beam Mantel' },
                { img: baseUrl + 'datas/prmedia/gallery/9-Fypon Column Wrap.png', name: 'Fypon Column Wrap' },
                { img: baseUrl + 'datas/prmedia/gallery/10-Fypon Flat Trim.png', name: 'Fypon Flat Trim' },

            ],
            parent : 'prmedia_fypon',

    },
    {
        area :'PR & Media Fypon',
        ref : 'prmedia_fypon_tools_btn5_logos',
        navigationLevel : -1,
        type: 'gallery',
        images:
        [
            { img: 'logos_prmedia/FyponLogo_4C_Transparent.png', name: '' },


        ],
       
        title: 'Logos',
        parent : 'prmedia_fypon',
    },
    {
        ref: 'prmedia_fypon',
        area : 'PR & Media Fypon',
        title: 'Explore More Tools',
        info_default_view: false,
        info_navigation_view: true,
        navigationLevel: 2,
        navigation_box: '',
        discription: 'Fypon PR & Media',
        ContentComponents: [

            {
                navigation_ref: 'door_system',
                type: 'navigation_box',
                title: 'Door System Brochure',
                discription: 'Fypon PR & Media',
                footerdiscription: true,

                buttonList: [
                    {
                        key : 'prmedia_fypon_tools_btn1',
                        ref : 'prmedia_fypon_tools_btn1',
                        title: 'Press Releases ',
                        area : 'PR & Media Fypon',

                        contentKey: 'prmedia_fypon_tools_btn1_press_release',
                        type: 'navigationbuttonlist',

                    },
                    {

                        key : 'prmedia_fypon_tools_btn2',
                        ref : 'prmedia_fypon_tools_btn2',
                        title: 'Company Background',
                                area : 'PR & Media Fypon',

                        contentKey: 'prmedia_fypon_tools_btn2_company_background',
                        type: 'navigationbuttonlist',

                    },
                    {
                        key : 'prmedia_fypon_tools_btn3',
                        ref : 'prmedia_fypon_tools_btn3',
                        title: 'Brochures',
                        type : 'navigationbuttonlist',
                        area : 'PR & Media Fypon',

                        contentKey : 'prmedia_fypon_tools_btn3'
                    },
                    {
                        key : 'prmedia_fypon_tools_btn4',
                        ref : 'prmedia_fypon_tools_btn4',
                        title: 'Product Images',
                        area : 'PR & Media Fypon',

                        contentKey: 'prmedia_fypon_tools_btn4_product_images',
                        type: 'navigationbuttonlist',
                       
                    },
                    {
                        key : 'prmedia_fypon_tools_btn5',
                        ref : 'prmedia_fypon_tools_btn5',
                        type: 'navigationbuttonlist',
                        area : 'PR & Media Fypon',

                        contentKey: 'prmedia_fypon_tools_btn5_logos',
                        title: 'Logos',

                  
                    },
                    // {
                    //     title: 'Product Flyers',
                    //     type: 'pdf',
                    //     path: 'datas/fypon/fyponproducts/Fypon New Product Brochure Placeholder.pdf',
                    // },

                ]
            },

        ],
        navigationComponents: [
            // { key : 'door_system' , name: 'Door System Brochure'},

        ],


    },

    {
        ref : 'prmedia_fypon_tools_btn3',
        title : 'Brochures',
        area :'PR & Media Fypon',
    
        info_default_view : false,
        info_navigation_view : true,
        navigationLevel : 2,
        navigation_box : '',
        parent : 'prmedia_fypon',
        footerdiscription : true,
    
        ContentComponents: [
    
            {
                navigation_ref: 'door_system',
                type: 'navigation_box',
                title: 'Door System Brochure',
                footerdiscription : true,
                discription : 'Brochures',
    
                buttonList: [
                    {
                        title: '2023 Full Line Catalog',
                        type : 'navigationbuttonlist',
                        area :'PR & Media Fypon',

                        contentKey : 'prmedia_fypon_brochure_pdf1'
                        
                    },
                    {
                        title: '2023 New Product Brochure',
                        type : 'navigationbuttonlist',
                        area :'PR & Media Fypon',

                        contentKey : 'prmedia_fypon_brochure_pdf2'
    
                    },
                    {
                        title: 'Smooth Beam Mantels Fast Facts',
                        type : 'navigationbuttonlist',
                        area :'PR & Media Fypon',

                        contentKey : 'prmedia_fypon_brochure_pdf3'
    
                    },
                    {
                        title: 'Louvered & Raised Panel Shutter Heights Fast Facts ',
                        type : 'navigationbuttonlist',
                        area :'PR & Media Fypon',

                        contentKey : 'prmedia_fypon_brochure_pdf4'
    
                    },
                    {
                        title: 'Increasing Curb Appeal',
                        type : 'navigationbuttonlist',
                        area :'PR & Media Fypon',

                        contentKey : 'prmedia_fypon_brochure_pdf5'
    
                    },
                 
                ]
            },
    
        ],
        navigationComponents: [
            // { key : 'door_system' , name: 'Door System Brochure'},
    
        ],
    
    
    },
    {
        area :'PR & Media Fypon',
        title: '2023 Full Line Catalog',
        ref : 'prmedia_fypon_brochure_pdf1',
        navigationLevel : -1,
        path : baseUrl+'datas/prmedia/23_Fypon_Cat_Full-Line_LR.pdf',
        type : 'pdf',
        parent : 'prmedia_fypon_tools_btn3',
    },
    {
        area :'PR & Media Fypon',
        title: '2023 New Product Brochure',
        ref : 'prmedia_fypon_brochure_pdf2',
        navigationLevel : -1,
        path : baseUrl+'datas/prmedia/23 Fypon New Product Guide.pdf',
        type : 'pdf',
        parent : 'prmedia_fypon_tools_btn3',
    },
    {
        area :'PR & Media Fypon',
        title: 'Smooth Beam Mantels Fast Facts',
        ref : 'prmedia_fypon_brochure_pdf3',
        navigationLevel : -1,
        path : baseUrl+'datas/prmedia/Fypon_FastFacts_Smooth Mantels.pdf',
        type : 'pdf',
        parent : 'prmedia_fypon_tools_btn3',
    },
    {
        area :'PR & Media Fypon',
        title: 'Louvered & Raised Panel Shutter Heights Fast Facts',
        ref : 'prmedia_fypon_brochure_pdf4',
        navigationLevel : -1,
        path : baseUrl+'datas/prmedia/Fypon_FastFacts_RaisedPanelAndLouveredShutters.pdf',
        type : 'pdf',
        parent : 'prmedia_fypon_tools_btn3',
    },
    {
        area :'PR & Media Fypon',
        title: 'Increasing Curb Appeal',
        ref : 'prmedia_fypon_brochure_pdf5',
        navigationLevel : -1,
        path : baseUrl+'datas/prmedia/22_Fypon_NHVS_Brochure_SinglePages.pdf',
        type : 'pdf',
        parent : 'prmedia_fypon_tools_btn3',
    },

    //Explore Fypon Page Modal Poups
    {
        ref: 'explore_fypon_new_pr_tr_video_get_inspred',
        title: 'Explore More Tools',
        area : 'Explore Fypon',
        navigationLevel: -1,
        path: '',
        type: 'gallery',
        images:
            [
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_exterior/VE_Images_Exterior_1.jpg', name: 'Shutters, Dentil Blocks, Louver, Railing System, Column Wraps, Moulding, Trellis System, Gable Pediment, Crossheads' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_exterior/VE_Images_Exterior_2.jpg', name: 'Raised Panel Shutters' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_exterior/VE_Images_Exterior_3.jpg', name: 'Column Wraps, Decorative Louver, Burnham Gable Pediments, Trellis Systems, Board & Batten Shutters' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_exterior/VE_Images_Exterior_4.jpg', name: 'Louvered with Center Rail Shutters' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_exterior/VE_Images_Exterior_5.jpg', name: 'Brackets, Dentil Blocks' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_exterior/VE_Images_Exterior_6.jpg', name: 'Shaker-Style Shutters, Distinction Crossheads, Plain Pilasters, Flat Trim, Column Wraps' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_exterior/VE_Images_Exterior_7.jpg', name: 'Sullivan Gable Pediment, EverCedar Column Wraps' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_exterior/VE_Images_Exterior_8.jpg', name: 'Gable Pediments, Brackets, Craftsman Step Crossheads, Column Wraps, Flat Trim' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_exterior/VE_Images_Exterior_9.jpg', name: 'EverCedar Column Wraps, Corbels' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_exterior/VE_Images_Exterior_10.jpg', name: 'Fishscale Panels, Spires, Brackets, Dentil Blocks, Rail Systems, Column Wraps' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_exterior/VE_Images_Exterior_11.jpg', name: 'Column Wraps, Flat Trim, Brackets, Functional Louver' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_exterior/VE_Images_Exterior_12.jpg', name: 'Bullnose Rafter Tails' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_exterior/VE_Images_Exterior_13.jpg', name: 'Shaker-Style Shutters, Column Wraps, Craftsman Step Crossheads, Gable Pediment, Flat Trim, Brackets' },

            ]


    },

    {
        ref: 'explore_fypon_other_pr_tr_video_get_inspred',
        title: 'Explore More Tools',
        area : 'Explore Fypon',

        navigationLevel: -1,
        path: '',
        type: 'gallery',
        images:
            [
                { img: baseUrl + 'datas/fypon/fyponexplore/other_pr_inspired/VE_Images_Other_1.jpg', name: 'Premium Stair Kit for Square Spindles, Premium Complete Post Kit, Premium Square QuickPost Trim Kit' },
                { img: baseUrl + 'datas/fypon/fyponexplore/other_pr_inspired/VE_Images_Other_2.jpg', name: 'Premium Complete Post Kit, Premium Stair Kit for Square Spindles, Premium Rail Kit for Square Spindles' },
                { img: baseUrl + 'datas/fypon/fyponexplore/other_pr_inspired/VE_Images_Other_3.jpg', name: 'Premium Square QuickPost Trim Kit, QuickRail Straight Rail Kit, Smooth Flat Trim' },
                { img: baseUrl + 'datas/fypon/fyponexplore/other_pr_inspired/VE_Images_Other_4.jpg', name: 'Premium Rail Kit' },
                { img: baseUrl + 'datas/fypon/fyponexplore/other_pr_inspired/VE_Images_Other_5.jpg', name: 'Premium Rail Kit, QuickPost, QuickPost Trim Kit' },

            ]


    },

    {
        ref: 'explore_fypon_inter_pr__get_inspred',
        title: 'Explore More Tools',
        navigationLevel: -1,
        path: '',
        type: 'gallery',
        area : 'Explore Fypon',

        images:
            [
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_1.jpg', name: 'Stepped Mantel' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_2.jpg', name: 'Smooth Beams, Smooth Beam Mantel' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_3.jpg', name: 'Craftsman Cove Crosshead' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_4.jpg', name: 'Hand Hewn Beams, Hammered Beam Straps' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_5.jpg', name: 'Classic Crosshead, Moulding' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_6.jpg', name: 'Classic Mantel' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_7.jpg', name: 'Hand Hewn Beams, Hand Hewn Beam Mantel, Hand Hewn Beam Shelves' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_8.jpg', name: 'Brackets, Dentil Blocks, Moulding' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_9.jpg', name: 'Smooth Beams' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_10.jpg', name: 'Rough Sawn Beam Mantel' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_11.jpg', name: 'Distinction Crosshead with End Caps' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_12.jpg', name: 'Tahoe Beams' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_13.jpg', name: 'Smooth Flat Trim' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_14.jpg', name: 'Mesa Beams' },
                { img: baseUrl + 'datas/fypon/fyponexplore/get_inspired_interior/VE_Images_Interior_15.jpg', name: 'Smooth Beams, Stepped Mantel, Moulding' },

            ]

    },



    {
        ref: 'explore_fypon_new_pr_tr_literature',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        defaultType: 'pdf',
        childType: 'navigation',
        info_default_view: true,
        info_navigation_view: false,
        infoNavigationComponents: [],
        navigationLevel: 0,
        ContentComponents: [
            {
                navigation_ref: 'explore_fypon_new_pr_tr_literature_1',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Moulding+%26+Trim.pdf',
                title: 'Mouldings & Trim'
            },
            {
                navigation_ref: 'explore_fypon_new_pr_tr_literature_2',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Railing+Systems.pdf',
                title: 'Railing Systems'
            },


        ],
        navigationComponents: [
            { key: 'explore_fypon_new_pr_tr_literature_1', name: 'Mouldings & Trim', slider: false },
            { key: 'explore_fypon_new_pr_tr_literature_2', name: 'Railing Systems', slider: false },
        ]

    },

    {
        ref: 'explore_fypon_exterior_pr_tr_literature',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        defaultType: 'pdf',
        childType: 'navigation',
        info_default_view: true,
        info_navigation_view: false,
        infoNavigationComponents: [],
        navigationLevel: 0,
        ContentComponents: [
            {
                navigation_ref: 'explore_fypon_exterior_pr_tr_literature_1',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Gable Pediments.pdf',
                title: 'Gable Pediments'
            },
            {
                navigation_ref: 'explore_fypon_exterior_pr_tr_literature_2',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Column Wraps.pdf',
                title: 'Column Wraps'
            },
            {
                navigation_ref: 'explore_fypon_exterior_pr_tr_literature_3',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Trellis Systems.pdf',
                title: 'Trellis Systems'
            },
            {
                navigation_ref: 'explore_fypon_exterior_pr_tr_literature_4',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Louvered _ Raised Panel Shutters.pdf',
                title: 'Louvered & Raised Panel Shutters'
            },
            {
                navigation_ref: 'explore_fypon_exterior_pr_tr_literature_5',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Shaker-Style Shutters.pdf',
                title: 'Shaker-Style Shutters'
            },
            {
                navigation_ref: 'explore_fypon_exterior_pr_tr_literature_6',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Modern Farmhouse Shaker-Style Shutters.pdf',
                title: 'Modern Farmhouse Shaker-Style Shutters'
            },
            {
                navigation_ref: 'explore_fypon_exterior_pr_tr_literature_7',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Brackets, Corbels & Dentil Blocks.pdf',
                title: 'Brackets, Corbels & Dentil Blocks'
            },
            {
                navigation_ref: 'explore_fypon_exterior_pr_tr_literature_8',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Railing Systems.pdf',
                title: 'Railing Systems'
            },
            {
                navigation_ref: 'explore_fypon_exterior_pr_tr_literature_9',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Moulding & Trim.pdf',
                title: 'Moulding & Trim'
            },
            {
                navigation_ref: 'explore_fypon_exterior_pr_tr_literature_10',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Craftsman-Style Crossheads.pdf',
                title: 'Craftsman-Style Crossheads'
            },
        ],
        navigationComponents: [
            { key: 'explore_fypon_exterior_pr_tr_literature_1', name: 'Gable Pediments', slider: true, class: 'wid_25' },
            { key: 'explore_fypon_exterior_pr_tr_literature_2', name: 'Column Wraps', slider: true, class: 'wid_25' },
            { key: 'explore_fypon_exterior_pr_tr_literature_3', name: 'Trellis Systems', slider: true, class: 'wid_25' },
            { key: 'explore_fypon_exterior_pr_tr_literature_4', name: 'Louvered & Raised Panel Shutters', slider: true, class: 'wid_25' },
            { key: 'explore_fypon_exterior_pr_tr_literature_5', name: 'Shaker-Style Shutters', slider: true, class: 'wid_25' },
            { key: 'explore_fypon_exterior_pr_tr_literature_6', name: 'Modern Farmhouse Shaker-Style Shutters', slider: true, class: 'wid_25' },
            { key: 'explore_fypon_exterior_pr_tr_literature_7', name: 'Brackets, Corbels & Dentil Blocks', slider: true, class: 'wid_25' },
            { key: 'explore_fypon_exterior_pr_tr_literature_8', name: 'Railing Systems', slider: true, class: 'wid_25' },
            { key: 'explore_fypon_exterior_pr_tr_literature_9', name: 'Mouldings & Trim', slider: true, class: 'wid_50' },
            { key: 'explore_fypon_exterior_pr_tr_literature_10', name: 'Craftsman-Style Crossheads', slider: true, class: 'wid_50' },

        ]

    },

    {
        ref: 'explore_fypon_interior_pr_tr_literature',
        title: 'Explore More Tools',
        area : 'Explore Fypon',

        defaultType: 'pdf',
        childType: 'navigation',
        info_default_view: true,
        info_navigation_view: false,
        infoNavigationComponents: [],
        navigationLevel: 0,
        ContentComponents: [
            {
                navigation_ref: 'explore_fypon_interior_pr_tr_literature_1',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Wood-Grained Beams & Trusses.pdf',
                title: 'Wood-Grained Beams & Trusses'
            },
            {
                navigation_ref: 'explore_fypon_interior_pr_tr_literature_2',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Smooth Mantels.pdf',
                title: 'Smooth Mantels'
            },
            {
                navigation_ref: 'explore_fypon_interior_pr_tr_literature_3',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Smooth Beams.pdf',
                title: 'Smooth Beams'
            },
            {
                navigation_ref: 'explore_fypon_interior_pr_tr_literature_4',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Craftsman-Style Crossheads.pdf',
                title: 'Craftsman-Style Crossheads'
            },
            {
                navigation_ref: 'explore_fypon_interior_pr_tr_literature_5',
                type: 'pdf',
                path: baseUrl + 'datas/fypon/fyponproducts/Moulding & Trim.pdf',

                title: 'Mouldings & Trim'
            },


        ],
        navigationComponents: [
            { key: 'explore_fypon_interior_pr_tr_literature_1', name: 'Wood-Grained Beams & Trusses', slider: true, class: '' },
            { key: 'explore_fypon_interior_pr_tr_literature_2', name: 'Smooth Mantels', slider: true, class: '' },
            { key: 'explore_fypon_interior_pr_tr_literature_3', name: 'Smooth Beams', slider: true, class: '' },
            { key: 'explore_fypon_interior_pr_tr_literature_4', name: 'Craftsman-Style Crossheads', slider: true, class: 'wid_50' },
            { key: 'explore_fypon_interior_pr_tr_literature_5', name: 'Mouldings & Trim', slider: true, class: 'wid_50' },
        ]

    },

    {
        ref: 'explore_fypon_new_pr_tr_video_sample_order',
        area : 'Explore Fypon',
        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponproducts/Fypon New Product Brochure Placeholder.pdf',
        type: 'pdf',

    },

    {
        ref: 'fypon_explorer_home1_hs1',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/popup/Brackets, Corbels & Dentil Blocks.jpg',
        type: 'image',

    },

    {
        ref: 'fypon_explorer_home1_hs2',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/popup/Craftsman-Style Crossheads.jpg',
        type: 'image',

    },


    //Explore Fypon Home 1 SLider Hotspot assets Link
    {
        ref: 'gablepediment',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/home1/Gable Pediments.jpg',
        type: 'image',

    },
    {
        ref: 'dentilblock',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/home1/Brackets, Corbels & Dentil Blocks.jpg',
        type: 'image',

    },
    {
        ref: 'shakerstyleshutter',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/home1/Smooth Shutters.jpg',
        type: 'image',

    },
    {
        ref: 'louver',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/home1/Louvers & Gable Vents.jpg',
        type: 'image',

    },
    {
        ref: 'craftmanstylecrosshead',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/home1/Craftsman-Style Crossheads.jpg',
        type: 'image',

    },
    {
        ref: 'raisedpanelshutter',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/home1/Raised Panel Shutters.jpg',
        type: 'image',

    },
    {
        ref: 'coloumnwrap',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/home1/PremiumSelect Square Column Wraps.jpg',
        type: 'image',

    },
    {
        ref: 'railsystem_home1',
        area : 'Explore Fypon',
        title: 'Explore More Tools',
        navigationLevel: -1,
        // path: baseUrl + 'datas/fypon/fyponexplore/home1/Rail Systems.jpg',
        path: baseUrl + 'datas/fypon/fyponexplore/other/MicrosoftTeams-image.png',

        type: 'image',

    },
    {
        ref: 'trellissystem',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/home1/Trellis System.jpg',
        type: 'image',

    },


    {
        ref: 'smoothbeams',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/livingroom/Smooth Beams.jpg',
        type: 'image',

    },
    {
        ref: 'smoothmantels',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/livingroom/Smooth Mantels.jpg',
        type: 'image',

    },
    {
        ref: 'windowtrimsurroundings',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/livingroom/Window Trim & Door Surrounds.jpg',
        type: 'image',

    },



    {
        ref: 'beams',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/foyer/Wood-Grained Beams & Trusses.jpg',
        type: 'image',

    },
    {
        ref: 'foyr_craftmanstylecrosshead',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/foyer/Craftsman-Style Crossheads.jpg',
        type: 'image',

    },
    {
        ref: 'pilaster',
        title: 'Explore More Tools',
        area : 'Explore Fypon',

        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/foyer/Window Trim & Door Surrounds.jpg',
        type: 'image',

    },
    {
        ref: 'smoothflattrim',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/foyer/Window Trim & Door Surrounds.jpg',
        type: 'image',

    },


    {
        ref: 'premiumquickpost',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/other/QuickPost Porch Post.jpg',
        type: 'image',

    },
    {
        ref: 'flattrim',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/other/Window Trim & Door Surrounds.jpg',
        type: 'image',

    },
    {
        ref: 'railsystem_other',
        area : 'Explore Fypon',
        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/other/MicrosoftTeams-image.png',
        type: 'image',

    },
    {
        ref: 'doorsurrounds',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/other/Window Trim & Door Surrounds.jpg',
        type: 'image',

    },




    {
        ref: 'brackets',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/home2/Brackets, Corbels & Dentil Blocks.jpg',
        type: 'image',

    },


    {
        ref: 'fishscalepanels',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/home2/Fishscale Panels.jpg',
        type: 'image',

    },

    {
        ref: 'spires',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/home2/Spires.jpg',
        type: 'image',

    },

    {
        ref: 'dentilblocks',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/home2/Brackets, Corbels & Dentil Blocks (1).jpg',
        type: 'image',

    },

    {
        ref: 'railsystem_home2',
        area : 'Explore Fypon',
        title: 'Explore More Tools',
        navigationLevel: -1,
        // path: baseUrl + 'datas/fypon/fyponexplore/home2/Rail Systems (1).jpg',
        path: baseUrl + 'datas/fypon/fyponexplore/other/MicrosoftTeams-image.png',

        type: 'image',

    },



    {
        ref: 'columnwrap',
        area : 'Explore Fypon',

        title: 'Explore More Tools',
        navigationLevel: -1,
        path: baseUrl + 'datas/fypon/fyponexplore/home2/PremiumSelect Square Column Wraps.jpg',
        type: 'image',

    },

    {
        ref: 'rotation_keysuccess',
        title: 'Explore More Tools',
        navigationLevel: -1,
        path: '',
        type: 'keysuccess-rotation',

    },


    {
        area : 'The Therma-Tru Difference',

        ref: 'experience_image1_modal',
        title: 'Experiece Image Modal',
        defaultType: 'image',
        childType: 'navigation',
        navigationLevel: 0,

        ContentComponents: [
            {
                type: 'imageArray',
                imgArray: [
                    baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/VE_TTDifference_10434x12984.jpg',
                    baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/VE_60_Yrs_PopUp_2500x1500.jpg',
                ],
                path: '',
                title: 'New Product & Trends Video',
                hotspotNavigationNeed: true,
                classname: 'middle',
                hotspotNavigationNLocation: [
                    {
                        top: '23%',
                        left: '25%',
                        img: baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/23_VE_BBLeader_PopUp_2200x2800.jpg',
                        classname: '',

                    },
                    {
                        top: '55%',
                        left: '14%',
                        img: baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/VE_60_Yrs_PopUp_2500x1500.jpg',
                        classname: 'middle',

                    },
                    {
                        top: '86%',
                        left: '25%',
                        img: baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/VE_Veris_PopUp_2500x2000.jpg',
                        classname: 'bottom',
                    }
                ],
            },
        ],
        navigationComponents: [

        ]
    },

    {
        ref: 'experience_image2_modal',
        title: 'Experiece Image Modal',
        defaultType: 'image',
        childType: 'navigation',
        area : 'The Therma-Tru Difference',

        navigationLevel: 0,
        ContentComponents: [
            {
                type: 'imageArray',
                classname: 'bottom',

                imgArray: [
                    baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/VE_TTDifference_10434x12984.jpg',
                    baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/VE_Veris_PopUp_2500x2000.jpg',
                ],
                path: '',
                title: 'New Product & Trends Video',
                hotspotNavigationNeed: true,
                hotspotNavigationNLocation: [
                    {
                        top: '23%',
                        left: '25%',
                        img: baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/23_VE_BBLeader_PopUp_2200x2800.jpg',
                        classname: '',

                    },
                    {
                        top: '55%',
                        left: '14%',
                        img: baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/VE_60_Yrs_PopUp_2500x1500.jpg',
                        classname: 'middle',

                    },
                    {
                        top: '86%',
                        left: '25%',
                        img: baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/VE_Veris_PopUp_2500x2000.jpg',
                        classname: 'bottom',
                    }
                ],
            },
        ],
        navigationComponents: [

        ]
    },

    {
        ref: 'experience_image3_modal',
        title: 'Experiece Image Modal',
        defaultType: 'image',
        childType: 'navigation',
        area : 'The Therma-Tru Difference',

        navigationLevel: 0,
        ContentComponents: [
            {
                type: 'imageArray',
                classname: '',

                imgArray: [
                    baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/VE_TTDifference_10434x12984.jpg',
                    baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/23_VE_BBLeader_PopUp_2200x2800.jpg',
                ],
                path: '',
                title: 'New Product & Trends Video',
                hotspotNavigationNeed: true,
                hotspotNavigationNLocation: [
                    {
                        top: '23%',
                        left: '25%',
                        img: baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/23_VE_BBLeader_PopUp_2200x2800.jpg',
                        classname: '',

                    },
                    {
                        top: '55%',
                        left: '14%',
                        img: baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/VE_60_Yrs_PopUp_2500x1500.jpg',
                        classname: 'middle',

                    },
                    {
                        top: '86%',
                        left: '25%',
                        img: baseUrl + 'datas/thermatru/thermatru_difference/experience_thermatru/VE_Veris_PopUp_2500x2000.jpg',
                        classname: 'bottom',
                    }
                ],
            },
        ],
        navigationComponents: [

        ]
    },

    {
        ref: 'keysuccess_rules',
        area : 'Key 2 Success',

        title: 'RUles',
        navigationLevel: -1,
        path: '',
        type: 'keysuccess-rules',
        parent: 'rotation_keysuccess'
    },

    {
        ref: 'keysuccess_prize',
        area : 'Key 2 Success',

        title: 'Prize',
        navigationLevel: -1,
        path: '',
        type: 'keysuccess-prize',
        parent: 'rotation_keysuccess'
    },


    {
        ref: 'keysuccess_progress',
        area : 'Key 2 Success',

        title: 'Progress',
        navigationLevel: -1,
        path: '',
        type: 'keysuccess-progress',
        parent: 'rotation_keysuccess'
    },

    {
        ref: 'trust_experts_modal',
        title: 'trust experts',
        defaultType: 'image',
        childType: 'navigation',
        area : 'The Fypon Advantage',

        navigationLevel: 0,
        ContentComponents: [
            {
                type: 'imageArray',
                classname: '',

                imgArray: [
                    baseUrl + 'datas/fypon/fyponadvantage/discover_fypon/Pillar Graphic_BrandBuilder.jpg',
                    baseUrl + 'datas/fypon/fyponadvantage/discover_fypon/Trust the Experts in Polyurethane_Hotspot.jpg',
                ],
                path: '',
                title: 'trust experts',
                hotspotNavigationNeed: true,
                color: 'blue',
                hotspotNavigationNLocation: [
                    {
                        top: '37%',
                        left: '25%',
                        img: baseUrl + 'datas/fypon/fyponadvantage/discover_fypon/Trust the Experts in Polyurethane_Hotspot.jpg',
                        classname: '',

                    },
                    {
                        top: '60%',
                        left: '44%',
                        img: baseUrl + 'datas/fypon/fyponadvantage/discover_fypon/Discover the Fypon Advantage_Hotspot.jpg',
                        classname: 'bottom',

                    },
                ],
            },
        ],
        navigationComponents: [

        ]
    },
    {
        ref: 'discover_fypon_modal',
        title: 'discover fypon',
        defaultType: 'image',
        childType: 'navigation',
        area : 'The Fypon Advantage',

        navigationLevel: 0,
        ContentComponents: [
            {
                type: 'imageArray',
                classname: 'bottom',

                imgArray: [
                    baseUrl + 'datas/fypon/fyponadvantage/discover_fypon/Pillar Graphic_BrandBuilder.jpg',
                    baseUrl + 'datas/fypon/fyponadvantage/discover_fypon/Discover the Fypon Advantage_Hotspot.jpg',
                ],
                path: '',
                title: 'discover fypon',
                hotspotNavigationNeed: true,
                color: 'blue',
                hotspotNavigationNLocation: [
                    {
                        top: '37%',
                        left: '25%',
                        img: baseUrl + 'datas/fypon/fyponadvantage/discover_fypon/Trust the Experts in Polyurethane_Hotspot.jpg',
                        classname: '',

                    },
                    {
                        top: '60%',
                        left: '44%',
                        img: baseUrl + 'datas/fypon/fyponadvantage/discover_fypon/Discover the Fypon Advantage_Hotspot.jpg',
                        classname: 'bottom',

                    },

                ],
            },
        ],
        navigationComponents: [

        ]
    },
    {
        ref: 'takeoff_solution_modal',
        title: 'takeoff solution',
        defaultType: 'image',
        childType: 'navigation',
        area : 'The Fypon Advantage',

        navigationLevel: 0,
        ContentComponents: [
            {
                type: 'imageArray',
                classname: '',

                imgArray: [
                    baseUrl + 'datas/fypon/fyponadvantage/takeoff/Pillar Graphic_Takeoff.jpg',
                    baseUrl + 'datas/fypon/fyponadvantage/takeoff/Fypon Takeoff Solution_Hotspot.jpg',
                ],
                path: '',
                title: 'takeoff solution',
                hotspotNavigationNeed: true,
                color: 'blue',
                hotspotNavigationNLocation: [
                    {
                        top: '20%',
                        left: '40%',
                        img: baseUrl + 'datas/fypon/fyponadvantage/takeoff/Fypon Takeoff Solution_Hotspot.jpg',
                        classname: '',

                    },
                    {
                        top: '55%',
                        left: '25%',
                        img: baseUrl + 'datas/fypon/fyponadvantage/takeoff/Make Ordinary Extraordinary_Hotspot.jpg',
                        classname: 'middle',

                    },
                    {
                        top: '90%',
                        left: '40%',
                        img: baseUrl + 'datas/fypon/fyponadvantage/takeoff/Estimating jobs can take hours_Hotspot.jpg',
                        classname: 'bottom',
                    }
                ],
            },
        ],
        navigationComponents: [

        ]
    },
    {
        ref: 'ordinary_extraordinary_modal',
        title: 'ordinary extraordinary',
        defaultType: 'image',
        childType: 'navigation',
        area : 'The Fypon Advantage',

        navigationLevel: 0,
        ContentComponents: [
            {
                type: 'imageArray',
                classname: 'middle',

                imgArray: [
                    baseUrl + 'datas/fypon/fyponadvantage/takeoff/Pillar Graphic_Takeoff.jpg',
                    baseUrl + 'datas/fypon/fyponadvantage/takeoff/Make Ordinary Extraordinary_Hotspot.jpg',
                ],
                path: '',
                title: 'ordinary extraordinary',
                hotspotNavigationNeed: true,
                color: 'blue',
                hotspotNavigationNLocation: [
                    {
                        top: '20%',
                        left: '40%',
                        img: baseUrl + 'datas/fypon/fyponadvantage/takeoff/Fypon Takeoff Solution_Hotspot.jpg',
                        classname: '',

                    },
                    {
                        top: '55%',
                        left: '25%',
                        img: baseUrl + 'datas/fypon/fyponadvantage/takeoff/Make Ordinary Extraordinary_Hotspot.jpg',
                        classname: 'middle',

                    },
                    {
                        top: '90%',
                        left: '40%',
                        img: baseUrl + 'datas/fypon/fyponadvantage/takeoff/Estimating jobs can take hours_Hotspot.jpg',
                        classname: 'bottom',
                    }
                ],
            },
        ],
        navigationComponents: [

        ]
    },
    {
        ref: 'estimating_jobs_modal',
        title: 'estimating jobs',
        defaultType: 'image',
        childType: 'navigation',
        area : 'The Fypon Advantage',

        navigationLevel: 0,
        ContentComponents: [
            {
                type: 'imageArray',
                classname: 'bottom',

                imgArray: [
                    baseUrl + 'datas/fypon/fyponadvantage/takeoff/Pillar Graphic_Takeoff.jpg',
                    baseUrl + 'datas/fypon/fyponadvantage/takeoff/Estimating jobs can take hours_Hotspot.jpg',
                ],
                path: '',
                title: 'estimating jobs',
                hotspotNavigationNeed: true,
                color: 'blue',
                hotspotNavigationNLocation: [
                    {
                        top: '20%',
                        left: '40%',
                        img: baseUrl + 'datas/fypon/fyponadvantage/takeoff/Fypon Takeoff Solution_Hotspot.jpg',
                        classname: '',

                    },
                    {
                        top: '55%',
                        left: '25%',
                        img: baseUrl + 'datas/fypon/fyponadvantage/takeoff/Make Ordinary Extraordinary_Hotspot.jpg',
                        classname: 'middle',

                    },
                    {
                        top: '90%',
                        left: '40%',
                        img: baseUrl + 'datas/fypon/fyponadvantage/takeoff/Estimating jobs can take hours_Hotspot.jpg',
                        classname: 'bottom',
                    }
                ],
            },
        ],
        navigationComponents: [

        ]
    },


    {
        ref: 'profile_edit',
        area : '',
        title: '',
        navigationLevel: -1,
        path: '',
        type: 'profile_edit',
        parent: ''
    },
    {
        ref: 'web_info',
        area : '',
        title: '',
        navigationLevel: -1,
        path: '',
        type: 'web_info',
        parent: ''
    },
    {
        ref: 'welcome_info',
        area : '',
        title: '',
        navigationLevel: -1,
        path: '',
        type: 'welcome_info',
        parent: ''
    },
    {
        ref: 'sme_add_participant',
        area : '',
        title: '',
        navigationLevel: -1,
        path: '',
        type: 'sme',
        parent: ''
    },
    {
        ref: 'sme_add_new_participant',
        area : '',
        title: '',
        navigationLevel: -1,
        path: '',
        type: 'sme_add',
        parent: 'sme_add_participant'
    },
    

    // fypon_exterior_product_fypon_sample_order,
    // fypon_interior_product_fypon_sample_order
    // fypon_other_product_fypon_sample_order

]

